import React from 'react'
import "../../../App.css"

function FullpageLoader() {
  return (
    <div class="loading">Loading&#8230;</div>
  )
}

export default FullpageLoader